<template>
  <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="brands.isLoading">
    <el-row type="flex" justify="space-between" align="middle" class="mb-4">
      <p class="category-title ma-0">
        Brand
        <el-button
          @click="$router.push('/brand/create')"
          type="warning"
          icon="el-icon-plus"
          circle
          size="small"
          class="ml-3"
        ></el-button>
      </p>
      <el-col :span="16">
        <el-row type="flex" justify="end">
          <el-select
            v-model="optionView"
            size="small"
            placeholder="Select"
            @change="
              e => {
                toAnotherPage(page, e), settingTable(page, e);
              }
            "
            class="mr-2"
            style="width: 100px"
          >
            <el-option
              v-for="item in optionsView"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            size="small"
            v-model="form.search"
            placeholder="Search by name or code"
            style="width: 200px"
            class="mr-2"
            @keyup.enter.native="onSearch"
          ></el-input>

          <el-button type="primary" @click="onSearch" size="small">Search</el-button>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-table empty-text="Tidak ada data" :data="brands.data" style="width: 100%">
        <el-table-column sortable prop="id" label="ID" width="180"></el-table-column>
        <el-table-column sortable prop="principalId" label="Principal ID"></el-table-column>
        <el-table-column sortable prop="brandCode" label="Brand Code"></el-table-column>
        <el-table-column sortable prop="brandName" label="Brand Name" width="180"></el-table-column>
        <el-table-column sortable prop="description" label="Description">
          <template slot-scope="scope">
            <span class="truncate-text">{{ scope.row.description }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="brandLogo" label="Logo">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.brandLogo" fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="
                $router.push(`/brand/edit/${scope.row.id}`)
              "
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :total="brands.count"
          :current-page="parseInt(page)"
          @current-change="
            e => {
              toAnotherPage(e, optionView), settingTable(e, optionView);
            }
          "
          :page-size="parseInt(optionView)"
        ></el-pagination>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      value: false,
      form: {
        search: ""
      },
      optionsActive: [
        {
          value: true,
          label: "Active"
        },
        {
          value: false,
          label: "No Active"
        }
      ],
      id: null,
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      page: 1
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getBrand: "brand/GetBrands",
      deleteBrand: "brand/DeleteBrand"
    }),
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    handleDelete(idx, row) {
      this.$confirm(
        "This will permanently delete the file. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.deleteBrand(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          });
        });
    },
    toAnotherPage(page, limit) {
      this.$router.push({
        path: "/brand",
        query: { page: page, limit: limit }
      });
    },
    onSearch() {
      this.$router.replace({ path: "/brand", query: { page: 1, limit: 25 } })
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getBrand(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView
        }
      };
      this.getBrand(option);
    },
  },
  computed: {
    ...mapState({
      brands: state => state.brand.brands
    })
  },
  created() {
    this.page = this.$router.history.current.query.page;
    this.optionView = this.$router.history.current.query.limit;
    let option = {
      params: {
        page: this.page,
        limit: this.optionView
      }
    };
    this.getBrand(option);
  }
};
</script>

<style>
.el-select-dropdown__item {
}
.brand-title {
  text-align: left;
  font-size: 1.5rem;
}
</style>
